/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable no-param-reassign */
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { UserCredential } from "firebase/auth";
import { ResourceCentre } from "../interfaces/ResourceCentreInterface";
import getBranches from "../client-portal/common/services/branch";
import getAccount from "../client-portal/common/services/accounts";
import UserAccountModel from "../client-portal/common/models/user-account-model";
import { User } from "../interfaces/User";
import { ServiceProvider } from "../interfaces/ServiceProvidersInterface";
import { Booking } from "../interfaces/BookingInterfaces";
import getClientAppointments from "../client-portal/common/services/appointments";

interface ClientPortalInfo {
  user: UserAccountModel;
  branches: Array<Partial<ResourceCentre>>;
  selectedSp: ServiceProvider | null;
  selectedBranch: ResourceCentre | null;
  appointments: Booking[];
  resourceCentreId: number | null;
  clientId: number | null;
}

const initialData: ClientPortalInfo = {
  user: {
    policies: {},
    user: {} as User & { resourceCentreId: number },
    userCreds: {} as UserCredential
  },
  branches: [],
  selectedSp: null,
  selectedBranch: null,
  appointments: [],
  resourceCentreId: null,
  clientId: null
};

// Async thunk to fetch client details
export const getAccountDetails = createAsyncThunk(
  "clientPortalInfo/getAccountDetails",
  async (_, { rejectWithValue }) => {
    try {
      const response = await getAccount();
      return response;
    } catch (error) {
      return rejectWithValue(error.response?.data || "An error occurred");
    }
  }
);

export const getAppointments = createAsyncThunk(
  "clientPortalInfo/getAppointments",
  async (filter: { clientId: number; from: string; to: string }, { rejectWithValue }) => {
    try {
      const response = await getClientAppointments(filter.clientId, filter.from, filter.to);
      return response;
    } catch (error) {
      return rejectWithValue(error.response?.data || "An error occurred");
    }
  }
);

export const getRcBranches = createAsyncThunk(
  "clientPortalInfo/getBranches",
  async (rcId: number, { rejectWithValue }) => {
    try {
      const response = await getBranches(rcId);
      return response;
    } catch (error) {
      return rejectWithValue(error.response?.data || "An error occurred");
    }
  }
);

const clientPortalUserInfoSlice = createSlice({
  name: "clientPortalUserInfoSlice",
  initialState: initialData,
  reducers: {
    setIsClientPortal: (_, action) => action.payload,
    setSelectedSp: (state, action) => {
      state.selectedSp = action.payload;
    },
    setSelectedBranch: (state, action) => {
      state.selectedBranch = action.payload;
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(getAccountDetails.fulfilled, (state, { payload }) => {
        state.user = payload;
        state.resourceCentreId = payload.user.resourceCentreId;
        state.clientId = payload.user.id;
      })
      .addCase(getRcBranches.fulfilled, (state, { payload }) => {
        state.branches = payload as Array<Partial<ResourceCentre>>;
      })
      .addCase(getAppointments.fulfilled, (state, { payload }) => {
        state.appointments = payload;
      });
  }
});

export const { setIsClientPortal, setSelectedSp, setSelectedBranch } =
  clientPortalUserInfoSlice.actions;
export default clientPortalUserInfoSlice.reducer;
